import React, { Component } from "react";
import HistoricForm from "../HistoricForm/HistoricForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : VacationPage
Description : Compoente que alberga el formulario de Vacation definido en el directorio de componentes
Date Autor Modification
================================================================================
29/09/2022 Santiago Coca - Se define el componente
================================================================================ */

class HistoricPage extends Component {
    render() {
        return (
            <div>
                <HistoricForm />
            </div>
        )
    }
}

export default HistoricPage;